export default __webpack_public_path__ + "static/media/about3.be11bd54.JPG";